// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"a491c9b7","411":"c9eca80b"}[chunkId] + ".css";
};